<template>
  <v-app class="font_size">
    <router-view />
  </v-app>
</template>

<style lang="scss" scoped>
* {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
</style>

<!-- Legacy CSS first; booking-theme.css must load after to restore html font-size -->
<style scoped>
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";
@import "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css";
@import "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
</style>

<style>
@import "@/assets/booking-theme.css";
</style>

<style scoped>
.font_size {
  font-size: 16.8px;
}
</style>
